
import * as React from 'react';
import ReactPlayer from 'react-player';
import { Action } from 'widgets-for-react';
import { VideoLibraryBlockProps } from '../blocks/custom_blocks/widgets/videoLibraryBlock';

export type VideoProvider = string; // 'youtube' | 'vimeo';

export type VideoLightboxProps = {
  videoURL: string;
  provider: VideoProvider;
  closeText: string;
  isOpen: "open" | "close"
  setState: (output: Action<VideoLibraryBlockProps>) => void
}

interface State {
  playing: boolean
}
export default class VideoLightbox extends React.Component<VideoLightboxProps, State> {
  private plyrRef: any;

  constructor(props: VideoLightboxProps) {
    super(props);
    this.plyrRef = React.createRef();
    this.state = { playing: false }
  }

  playVideo = () => this.setState(s => ({...s, playing: true}))

  stopVideo = () => this.setState(s => ({...s, playing: false}))

  componentDidUpdate(prevProps: Readonly<VideoLightboxProps>, prevState: Readonly<State>, snapshot?: any): void {
      if (prevProps.isOpen != this.props.isOpen) {
        if (this.props.isOpen == 'open') {
          this.playVideo()
        } else {
          this.stopVideo()
        }
      }
  }



  render(): React.ReactNode {
    let {
      closeText,
      provider,
      isOpen,
      videoURL,
      setState,
    } = this.props

    return <div className={`lightbox--${isOpen}`}>
      <div className="lightbox">
        <div className="lightbox__inner container container--m grid--block">
          <button className="lightbox__close close"
            onClick={e => {
              this.stopVideo()
              setState(s1 => ({ ...s1, isOpen: "close", selected_video_type: "", selected_video_url: "" }))
              document.documentElement.classList.remove('lightbox--open')
            }}>
            <span className="close__label sr-text">{closeText}</span>
            <svg className="close__icon" aria-hidden="true" width="14" height="14">
              <use xlinkHref="#icon--close"></use>
            </svg>
          </button>
          <figure className="lightbox__figure">
            <div className="lightbox__video">
              <ReactPlayer
                playing={this.state.playing}
                url={videoURL}
                controls
                height={"100%"}
                width={"100%"}
              />
            </div>
          </figure>
        </div>
      </div>
    </div>

  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/videoLightbox.tsx